// =============================================================================
// Przycisk „Aktywuj 14-dniowy trial" na karcie modułu — z blokadą planu.
//
// Wydzielony z `ModulesPage`, żeby blokadę dało się zmierzyć renderem: moduł
// powyżej planu Universe organizacji (`moduly_wymagany_plan`, migracja 754)
// ma przycisk WYŁĄCZONY, a zdanie z bazy w podpowiedzi i pod przyciskiem.
// `blokada = null` (plan wystarcza albo ocena niedostępna) — przycisk czynny,
// a ewentualną odmowę powie baza.
// =============================================================================

import { Loader2, Zap } from 'lucide-react';

export function PrzyciskProbyModulu({
  blokada,
  aktywuje,
  onAktywuj,
}: {
  /** Zdanie blokady planu albo `null`, gdy nic nie blokuje. */
  blokada: string | null;
  aktywuje: boolean;
  onAktywuj: () => void;
}) {
  return (
    <>
      <button
        onClick={onAktywuj}
        disabled={aktywuje || blokada !== null}
        title={blokada ?? undefined}
        className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-aurora-on-accent rounded-ids-md font-medium hover:from-blue-600 hover:to-purple-700 transition-colors disabled:opacity-50"
      >
        {aktywuje ? <Loader2 className="w-5 h-5 animate-spin" /> : <Zap className="w-5 h-5" />}
        Aktywuj 14-dniowy trial
      </button>
      {blokada && <p className="text-center text-xs text-amber-400">{blokada}</p>}
    </>
  );
}
